import each from 'lodash/each'

export default class Preloader {
  constructor(props) {
    this.props = props
    this.elements = { images: this.props.info }

    this.complete = false
    this.progress = 0
    this.params = ''
    this.loaded = 0
    this.total = this.elements.images.length

    this.onPreload()
  }

  onPreload() {
    each(this.elements.images, element => {
      const image = new Image()
      image.src = element
      image.onLoad = this.onLoaded(image)
    })
  }

  onProgress() {
    this.params = `${this.progress}%`
    //console.log(this.params)
  }

  onLoaded(image) {
    this.onProgress()

    this.loaded += 1
    this.progress = Math.ceil(this.loaded * 100 / this.total)
    if (this.loaded >= this.total) this.onComplete()
  }

  onComplete() {
    this.complete = true
    return true
  }
}